import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  base: {
    marginTop: 0,
    marginBottom: 0,
  },

  h1: {
    ...theme.typography.headings.main,
    marginBottom: theme.settings.spacing.large,
  },

  h2: {
    ...theme.typography.headings.normal,
    marginBottom: theme.settings.spacing.large,
  },

  h3: {
    ...theme.typography.headings.small,
    marginBottom: theme.settings.spacing.small,
  },

  h4: {
    ...theme.typography.headings.xSmall,
    marginBottom: theme.settings.spacing.small,
  },

  h5: {
    ...theme.typography.headings.xxSmall,
    marginBottom: theme.settings.spacing.small,
  },

  h6: {
    ...theme.typography.headings.xxxSmall,
    marginBottom: theme.settings.spacing.xSmall,
  },

  bold: {
    fontWeight: 600,
  },

  flush: {
    marginBottom: 0,
    padding: 0,
  },

  variants: {
    regular: {
      color: theme.colors.text.normal,
    },
    dim: {
      color: theme.colors.text.dimmed,
    },
    white: {
      color: theme.colors.text.light,
    },
    inherit: {
      color: 'inherit',
    },
    primary: {
      color: theme.colors.accents.primary,
    },
    secondary: {
      color: theme.colors.accents.secondary,
    },
    negative: {
      color: theme.colors.accents.negative,
    },
    positive: {
      color: theme.colors.accents.positive,
    },
    alert: {
      color: theme.colors.accents.alert,
    },
    cta: {
      color: theme.colors.accents.cta,
    },
    brand: {
      color: theme.colors.accents.brand,
    },
  },
})
